export default __webpack_public_path__ + "static/media/icon9.b7ca56a2.svg";